import { Card,Typography, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { saasModernTheme } from 'common/theme/saasModern';
import { background } from 'styled-system';

export const CategoryLabel = styled(Typography)(({ theme }) => ({
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
    fontSize: '14px',
    fontWeight: '400',
    color: '#111927',
  }));

  export const AIAvatar = styled(Avatar)(({ theme, bgcolor }) => ({
    backgroundColor: 'transparent',
    width: '40px',
    height: '40px',
  }));

  export const CardCat = styled(Card)(({ theme }) => ({
    height: '100%',
    boxShadow: 'none',
    background: '#FFFFFF',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    border: '1px solid #FFFFFF',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'scale(1.10)',
      background:'#F9FAFB',
    boxShadow: saasModernTheme.gradiantShadow,

    },
  }));
  

  export const TypoDescCard = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    fontWeight: '400',
    color: '#636F81',
    display: '-webkit-box',
    WebkitLineClamp: 3, // Limite à 3 lignes
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    fontSize: '14px', 
    width: '100%' 
  }));

  export const TextNameCard = styled(Typography)(({ theme }) => ({
    fontSize: '16px',
    fontWeight: '700',
    color: '#111927',

  }));